/** Within this many days of the end, the line turns into a gentle warning. */
export const ACCESS_ENDS_WARN_DAYS = 7;
const DAY_MS = 24 * 60 * 60 * 1000;

/** True when `accessEndsAt` falls within the warning window from `now`. */
export function accessEndsSoon(accessEndsAt: string, now: Date = new Date()): boolean {
  const ends = new Date(accessEndsAt).getTime();
  return !Number.isNaN(ends) && ends - now.getTime() <= ACCESS_ENDS_WARN_DAYS * DAY_MS;
}
